module.exports = __webpack_public_path__ + "static/media/bike-placeholder.b3ab9d45.svg";